export default function throttleV2(fun, delay = 2000) {
  let last, deferTimer
  return function (args) {
    const that = this
    const _args = arguments

    const now = +new Date()

    if (last && now < last + delay) {
      clearTimeout(deferTimer)
      deferTimer = setTimeout(function () {
        last = now
        fun.apply(that, _args)
      }, delay)
    } else {
      last = now
      fun.apply(that, _args)
    }
  }
}
